export default "__VITE_ASSET__Ax1rtodB__"